import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from 'src/api/axiosClient/types';
import { RootState } from 'src/store';
import { SurveyListItem } from '../types';
import { SurveyResponsesState } from './types';
import { DEFAULT_SURVEY_TIME_PERIOD } from '../types/SurveyTimePeriod';

const initialState: SurveyResponsesState = {
  loading: {
    getList: false,
  },
  filter: {
    companyId: '',
    sort: 'updatedAt_desc',
    offset: 0,
    limit: 25,
    page: 0,
    timePeriod: DEFAULT_SURVEY_TIME_PERIOD,
    startDateInterval: null,
    endDateInterval: null,
  },
  list: null,
  error: null,
};

const surveyResponsesSlice = createSlice({
  name: 'surveyResponses',
  initialState,
  reducers: {
    setLoading: (
      state,
      action: PayloadAction<Partial<Record<keyof SurveyResponsesState['loading'], boolean>>>,
    ) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter(state, action: PayloadAction<Partial<SurveyResponsesState['filter']>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    setList: (
      state,
      action: PayloadAction<{
        items: SurveyListItem[];
        count: number;
      }>,
    ) => {
      state.list = action.payload;
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    resetList: state => {
      state.list = initialState.list;
    },
    resetFilter: state => {
      state.filter = initialState.filter;
    },
    resetError: state => {
      state.error = initialState.error;
    },
    resetSlice: () => {
      initialState;
    },
  },
});

export const isSurveyResponsesLoading = (state: RootState) => state.surveyResponses.loading;

export const getSurveyResponses = (state: RootState) => state.surveyResponses.list;

export const isSurveyResponsesError = (state: RootState) => state.surveyResponses.error;

export const {
  setLoading,
  setFilter,
  setList,
  setError,
  resetList,
  resetFilter,
  resetError,
  resetSlice,
} = surveyResponsesSlice.actions;

export const surveyResponsesReducer = surveyResponsesSlice.reducer;
